import {
    apiRequest,
    riwayatPangkatDetail,
    riwayatPangkatUploadSK
} from "../../../../../services/adapters/kepegawaian/riwayatPangkatService"

class UploadSKRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatPangkatDetail, {
            params: query
        }, true)
    }

    fetchUploadSk = async (query) => {
        return await apiRequest("post", riwayatPangkatUploadSK, {
            body: query
        }, true)
    }

}

export default UploadSKRepository